import { render, staticRenderFns } from "./formGroups.vue?vue&type=template&id=3d6e772a&scoped=true"
import script from "./formGroups.vue?vue&type=script&lang=js"
export * from "./formGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e772a",
  null
  
)

export default component.exports